<template>
    <div id="Tabs" class="text-left">
        <div class="row">
            <div class="col-2 col-md-1">
                <a href="/" class="btn btn-outline-secondary">{{ "<" }}</a>
            </div>
            <div class="col-10 col-md-11 text-left">
                <b-button-group>
                    <b-dropdown variant="outline-secondary" :text="this.currentRoute">
                        <b-dropdown-item href='/medicalcare'>
                            <font-awesome-icon :icon="['fas', 'stethoscope']" /> 
                            &nbsp;
                            {{ this.simulationTypes.medicalCare.value }}
                        </b-dropdown-item>
                        <b-dropdown-item href='/dentalcare'>
                            <font-awesome-icon :icon="['fas', 'tooth']" />  
                            &nbsp;
                            {{ this.simulationTypes.dentalCare.value }}
                        </b-dropdown-item>
                        <b-dropdown-item href='/opticalcare'>
                            <font-awesome-icon :icon="['fas', 'glasses']" />  
                            &nbsp;
                            {{ this.simulationTypes.opticalCare.value }}
                        </b-dropdown-item>
                        <b-dropdown-item href='/hospitalization'>
                            <font-awesome-icon :icon="['fas', 'hospital']" />  
                            &nbsp;
                            {{ this.simulationTypes.hospitalization.value }}
                        </b-dropdown-item>
                    </b-dropdown>
                </b-button-group>
            </div>
        </div>
    </div>
</template>

<script>
import  { simulationTypes }  from "../helpers/types"
import  router  from "../router/index"

export default {
    computed: {
        simulationTypes: function () {
            return simulationTypes
        },
        currentRoute: function () {
            return router.getPathTitle(this.$route.path)
        },
        // mainButtonClass () { return Branding.getMainButtonClass() }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/Selection.vue